import { Center, Loader } from "@mantine/core";

export const LoadingPane = () => {
  return (
    <Center>
      <Loader size="xl" />
    </Center>
  );
};

export default LoadingPane;
